// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterFrontImage_root__16y88","title":"AfterFrontImage_title__1NU11"};